// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jKTH4","header":"styles_header__hDq8t","footer":"styles_footer__VSVua","main":"styles_main__UEbay"};